module.exports = __webpack_public_path__ + "img/motorbikeOverview3Outline.1e95202b.svg";